<template>
  <div class="page" v-if="detailInfo">
    <div class="order-num">订单编号：{{ detailInfo.orderId }}</div>
    <!-- 学生兑换状态 -->
    <div class="exchange-status">
      <el-steps
        :active="exchangeStatus"
        process-status="wait"
        finish-status="finish"
        align-center
      >
        <el-step
          title="学生兑换"
          :description="detailInfo.createTime"
          icon="el-icon-circle-check"
        ></el-step>
        <el-step
          :title="
            detailInfo.orderState === 0
              ? '未领取'
              : detailInfo.orderState === 1
              ? '驳回'
              : '已领取'
          "
          :description="
            detailInfo.orderState === 0
              ? ''
              : detailInfo.orderState === 1
              ? detailInfo.updateTime
              : detailInfo.exchangeTime
          "
          icon="el-icon-circle-check"
        ></el-step>
      </el-steps>
    </div>
    <!-- 商品信息 -->
    <div class="goods-info">
      <div class="title">商品信息</div>
      <div class="content">
        <div class="goods-img">
          <img :src="detailInfo.highPictureUrl" alt="" />
        </div>
        <div class="goods-detail">
          <div class="goods-title">
            {{ detailInfo.productName }}
          </div>
          <div class="goods-num">商品编号：{{ detailInfo.productNumber }}</div>
          <div class="exchange-num">兑换数量：{{ detailInfo.exchangeNum }}</div>
          <div class="price">
            <!-- 实际支付 -->
            <div class="actual-pay">
              实际支付
              <span
                ><strong>{{ detailInfo.consumeStarNum }}</strong> 星币</span
              >
            </div>
            <!-- 老师操作状态 -->
            <div class="teacher-choose">
              <el-radio
                v-model="paramsRadio"
                label="2"
                :disabled="detailInfo.orderState !== 0"
                >学生已领取商品</el-radio
              >
              <el-radio
                v-model="paramsRadio"
                label="1"
                :disabled="detailInfo.orderState !== 0"
                >驳回</el-radio
              >
            </div>
          </div>
          <div class="reject-text" v-if="paramsRadio === '1'">
            <el-input
              :disabled="!(paramsRadio === '1') || detailInfo.orderState === 1"
              type="textarea"
              placeholder="请输入驳回原因,30字以内"
              clearable
              show-word-limit
              :maxlength="30"
              resize="none"
              v-model="paramsRejectText"
            ></el-input>
          </div>
        </div>
      </div>
    </div>
    <!-- 操作按钮 -->
    <div class="operation" v-if="detailInfo.orderState === 0">
      <el-button size="small" @click="cancelEdit">取消</el-button>
      <el-button type="primary" size="small" @click="confirmEdit"
        >确定</el-button
      >
    </div>
  </div>
</template>
<script>
import {
  api_schoolOrderCheckDetial,
  api_schoolOrderApproval,
} from '@/api/javaApi'

export default {
  name: 'orderDetail',
  data: () => ({
    exchangeStatus: 1,
    paramsRadio: '',
    paramsRejectText: '',
    detailInfo: null,
  }),
  created() {
    console.log(this.$route)
    this.getOrderDetail()
  },
  methods: {
    getOrderDetail() {
      api_schoolOrderCheckDetial({ id: this.$route.query.id }).then((res) => {
        console.log(res)
        this.detailInfo = res
        this.paramsRadio = String(res.orderState)
        this.paramsRejectText = res.rejectReason
        this.exchangeStatus = res.orderState === 0 ? 1 : 2
        this.detailInfo.pictureUrl =
          this.$store.state.resource.picBaseUrl + this.detailInfo.pictureUrl
        this.detailInfo.highPictureUrl =
          this.$store.state.resource.picBaseUrl + this.detailInfo.highPictureUrl
      })
    },
    cancelEdit() {
      this.$router.back()
    },
    confirmEdit() {
      const params = {
        id: this.detailInfo.orderId, // 订单Id
        userName: this.$store.state.user.userInfo.realName, // 用户名称
        state: this.paramsRadio, // 审批状态（1驳回，2通过）
        productId: this.detailInfo.productId, // 商品Id
        consumeStarNum: this.detailInfo.consumeStarNum, // 兑换星币数
        rejectReason: this.paramsRejectText || null,
        eduCampusId: this.$route.query.eduCampusId,
        stuId: this.$route.query.stuId,
      }
      api_schoolOrderApproval(params).then((res) => {
        console.log(res)
        // this.$router.back()
        this.$router.replace({
          name: 'orderManagement',
          query: { refresh: true },
        })
      })
    },
  },
}
</script>
<style scoped lang="scss">
.page {
  box-sizing: border-box;
  width: 100%;
  height: 100%;
  padding: 20px 30px;
  background: #ffffff;
  box-shadow: 0px 0px 4px 0px #f0f4f5;
  border-radius: 5px;
  border: 1px solid #f4f5f9;

  .order-num {
    padding-bottom: 20px;
    font-weight: 500;
    font-size: 16px;
    color: #0a1629;
    line-height: 22px;
    letter-spacing: 1px;
  }

  .exchange-status {
    padding: 20px 20px 30px;
    margin-bottom: 35px;
    background: #ffffff;
    border-radius: 10px;
    border: 1px solid #e5e5e5;
  }

  .goods-info {
    padding: 30px;
    margin-bottom: 30px;
    background: #f8f8f8;
    border-radius: 10px;
    .title {
      padding-bottom: 20px;
      font-weight: 400;
      font-size: 16px;
      color: #0a1629;
      line-height: 22px;
    }
    .content {
      display: flex;
      .goods-img {
        flex-shrink: 0;
        width: 165px;
        height: 165px;
        margin-right: 20px;
        background: #ffffff;
        border: 1px solid #eeeeee;
        border-radius: 5px;
        overflow: hidden;
        img {
          display: block;
          width: 100%;
        }
      }
      .goods-detail {
        width: 100%;
        font-size: 14px;
        .goods-title {
          padding-top: 7px;
          padding-bottom: 15px;
          font-weight: 400;
          color: #0a1629;
          line-height: 20px;
          letter-spacing: 1px;
        }
        .goods-num {
        }
        .exchange-num {
          padding: 25px 0;
          font-weight: 400;
          font-size: 12px;
          color: #666666;
        }
        .price {
          display: flex;
          .actual-pay {
            margin-right: 150px;
            font-weight: 600;
            span {
              color: #1678ff;
              strong {
                font-size: 16px;
              }
            }
          }
          .teacher-choose {
            /deep/ .el-radio {
              font-size: 18px;
              .el-radio__input {
                .el-radio__inner {
                  width: 18px;
                  height: 18px;
                }
              }
              .el-radio__label {
                font-size: 18px;
              }
            }
          }
        }
      }
      .reject-text {
        padding-top: 30px;
      }
    }
  }

  .operation {
    display: flex;
    justify-content: flex-end;
  }
}
</style>
